import React, { useEffect, useState } from "react";
import { Button, Card, Col, Flex, Row, Table, Typography } from "antd";

import PageTitle from "../../components/PageTitle";
import IntlMessage from "../../components/IntlMessage";
import _, { debounce } from "lodash";
import busOrdersApi from "../../api/bus_orders";
import PreviewSeatMap from "../seat-map/PreviewSeatmap";
import dayjs from "dayjs";
import FilterBookingStatistic from "./FilterBookingStatistics";
import routesApi from "../../api/route";
import { useSelector } from "react-redux";

const { Text } = Typography;

const BookingStatistics = () => {
  const [loading, setLoading] = useState(false);
  const [itemSeatmap, setItemSeatmap] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [bookingStatistics, setBookingStatistics] = useState([]);
  const [total, setTotal] = useState(1);
  const [condition, setCondition] = useState({});
  const [reload, setReload] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [routesData, setRoutesData] = useState([]);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [routeItem, setRouteItem] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    // start_date: dayjs(new Date()).format("YYYY-MM-DD"),
    // end_date: dayjs().add(5, "day").format("YYYY-MM-DD"),
    // route_id: 1167,
  });

  const operator = useSelector((state) => state.auth.operator);

  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);

        const filter_route = {
          page: 1,
          limit: 9999,
          keyword: "",
          order_by: "id",
          order_dir: "DESC",
          filter_name: ["operator_id"],
          filter_value: [operator?.id],
        };

        const route_data = await routesApi.getAllRoutesOperator(filter_route);
        if (route_data) {
          setRoutesData(route_data?.data);
        }
        const getBookingStatistics = await busOrdersApi.getBookingStatistics(
          filter
        );
        if (getBookingStatistics?.route?.id) {
          const filter_route_detail = {
            page: 1,
            limit: 1,
            keyword: "",
            filter_name: ["id"],
            filter_value: [getBookingStatistics?.route?.id],
          };
          const routes_detail = await routesApi.getAll(filter_route_detail);
          if (routes_detail) {
            setRouteItem(routes_detail.data[0]);
          }
        }
        if (getBookingStatistics) {
          setBookingStatistics(getBookingStatistics?.route?.booked_seat);
          setTotal(getBookingStatistics?.total);
          setLoadingFilter(false);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [filter, refresh, operator]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const columns = [
    {
      title: <IntlMessage id="global.date" />,
      key: "date",
      dataIndex: "date",
      width: 70,
      render: (text, record, index) => {
        return <Text>{record?.date}</Text>;
      },
    },
    {
      title: <IntlMessage id="global.weekday" />,
      key: "day_of_week",
      width: 70,
      dataIndex: "day_of_week",
      render: (text, record, index) => {
        return (
          <>
            <Text key={index}>{record?.day_of_week}</Text>
          </>
        );
      },
    },
    {
      title: <IntlMessage id="global.statistic" />,
      key: "booked_seat",
      width: 350,
      dataIndex: "booked_seat",
      render: (text, record, index) => {
        return (
          <>
            <Flex vertical gap={12}>
              <Text key={index}>
                <IntlMessage id="global.booked_seat" />:{" "}
                {record.booked_seat.length > 0
                  ? record?.booked_seat.join(", ")
                  : "No seats have been booked"}
              </Text>
              <Text key={index}>
                <IntlMessage id="global.disabled_seats" />:{" "}
                {record?.disabled_seat?.length > 0
                  ? record?.disabled_seat
                      .filter((seat) => seat !== "")
                      .join(", ")
                  : "No seats have been disbaled"}
              </Text>
            </Flex>
          </>
        );
      },
    },
    {
      title: <IntlMessage id="global.preview_seat_map" />,
      key: "seatmap",
      width: 350,
      dataIndex: "seatmap",
      render: (text, record, index) => {
        return (
          <>
            <Button
              type="link"
              size="small"
              onClick={() => onOpenPreviewSeatMap(record)}
              shape="round"
            >
              <IntlMessage id="global.view_seat_map" />
            </Button>
          </>
        );
      },
    },
  ];

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "DESC";
  };

  const onChangeTable = (pagination, filters, sorter) => {
    const currentFilter = {
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
    };
    setFilter(currentFilter);
    if (pagination.pageSize !== filter.page) {
      setBookingStatistics([]);
    }
  };

  const onOpenPreviewSeatMap = (record = null) => {
    setIsPreview(true);
    setItemSeatmap(record);
  };

  const onFilter = debounce((value, name, type) => {
    if (type === "search") {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [name]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
    }
  }, 300);

  const onRefresh = () => {
    setRefresh((refresh) => !refresh);
  };

  const onReload = () => {
    setReload((reload) => !reload);
  };

  return (
    <Card bordered={false} style={{ minHeight: "100%" }}>
      <Row justify="space-between">
        <Col>
          <PageTitle title={<IntlMessage id="global.booking_statistics" />} />
        </Col>
      </Row>

      <Card bordered={false}>
        <Flex vertical gap={8}>
          <FilterBookingStatistic
            onFilter={onFilter}
            filter={filter}
            loadingFilter={loadingFilter}
            setLoadingFilter={setLoadingFilter}
            setFilter={setFilter}
            data={[
              {
                name: "routes",
                data: routesData,
                placeholder: <IntlMessage id="global.routes" />,
              },
            ]}
          />
          <Table
            columns={columns}
            pagination={{
              limit: filter.limit,
              current: filter.page,
              total: total,
            }}
            bordered
            size="small"
            tableLayout="auto"
            scroll={{ x: isMobile ? "max-content" : "" }}
            onChange={onChangeTable}
            dataSource={bookingStatistics}
            // rowSelection={rowSelection}
            loading={loading}
            // scroll={{ x: 1000 }}
            rowKey="id"
          />
        </Flex>
      </Card>

      {isPreview ? (
        <PreviewSeatMap
          open={isPreview}
          isModal={true}
          onClose={() => setIsPreview(false)}
          onReload={onReload}
          bookingStatisticRouteData={itemSeatmap}
          routeItem={routeItem}
        />
      ) : null}
    </Card>
  );
};

export default BookingStatistics;
